import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import useAnalyticStore from '../analyticStore/useAnalyticStore';
import useApiStore from '../apiStore/useApiStore';
import useAttributionStore from '../attributionStore/useAttributionStore';
import useLeadChannelStore from '../leadChannelStore/useLeadChannelStore';
import useParameterStore from '../parameterStore/useParameterStore';
import useRouteStore from '../routeStore/useRouteStore';
import { keysToPersist, userStore } from './userStore';

const useUserStore = createStore({
  creator: userStore({
    useAnalyticStore: lazyDependency(() => useAnalyticStore),
    useApiStore: lazyDependency(() => useApiStore),
    useAttributionStore: lazyDependency(() => useAttributionStore),
    useLeadChannelStore: lazyDependency(() => useLeadChannelStore),
    useParameterStore: lazyDependency(() => useParameterStore),
    useRouteStore: lazyDependency(() => useRouteStore),
  }),
  id: 'user',
  middlewares: {
    devtools: true,
    persist: {
      partialize: (state) => pickState(state, keysToPersist),
    },
  },
  persistHMR: true,
});

export default useUserStore;
